import React from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import {Icon} from 'epic-diesel-common';
import {Tooltip} from '../../../../components';
import useStyles from './EarningStatistic.styles';
import EarningStatisticSkeleton from '../skeleton/EarningStatisticSkeleton';

export interface EarningStatisticProps {
    isRendering?: boolean;
    title: React.ReactNode;
    tipTitle: React.ReactNode;
}

const EarningStatistic: React.FC<EarningStatisticProps> = ({
    isRendering = false,
    title,
    tipTitle,
    children
}) => {
    const styles = useStyles();

    if (isRendering) {
        return <EarningStatisticSkeleton>{children}</EarningStatisticSkeleton>;
    }

    return (
        <Box className={styles.root}>
            <Box className={styles.header}>
                <Typography variant="h4" className={styles.title}>
                    {title}
                </Typography>

                <Tooltip
                    arrow
                    className={styles.tooltipWrapper}
                    classes={{tooltip: styles.tooltip}}
                    title={tipTitle}
                    placement="left">
                    <span>
                        <Icon icon="QUESTION" />
                    </span>
                </Tooltip>
            </Box>
            {children}
        </Box>
    );
};

export default EarningStatistic;
